var map = {
	"./arrow-down.svg": 4746,
	"./arrow-fill-down.svg": 3896,
	"./arrow-map.svg": 1399,
	"./arrow-right.svg": 153,
	"./arrows.svg": 9177,
	"./back-arrow.svg": 2708,
	"./box.svg": 4799,
	"./cancel.svg": 7373,
	"./checkbox-un.svg": 8707,
	"./checkbox.svg": 6369,
	"./confirm.svg": 8138,
	"./copy.svg": 7918,
	"./dot.svg": 2583,
	"./download-full.svg": 9195,
	"./download.svg": 9007,
	"./envelope-close.svg": 2866,
	"./eye-cross.svg": 6946,
	"./eye.svg": 5564,
	"./file-xlsx.svg": 7622,
	"./filter-active.svg": 3075,
	"./filter-inactive.svg": 9072,
	"./filters-fill.svg": 4882,
	"./filters.svg": 9875,
	"./info.svg": 7292,
	"./invite-success.svg": 9554,
	"./invoice.svg": 870,
	"./link-out.svg": 4180,
	"./link.svg": 7966,
	"./lock-locked.svg": 2045,
	"./no-shipment.svg": 3778,
	"./package-filling.svg": 3854,
	"./pencil.svg": 1265,
	"./print.svg": 5131,
	"./success-empty.svg": 8356,
	"./success.svg": 4398,
	"./trash-success.svg": 4131,
	"./trash.svg": 967,
	"./warning-full.svg": 5610,
	"./warning.svg": 9800,
	"./x-mark.svg": 868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;